export default __webpack_public_path__ + "static/media/laser3.cb373881.mp3";